export const ModelMyPerfil = () => ({
    Nombre: { value: "", type: 'text', valid: true, hidden: false, required: true },
    Apellido: { value: "", type: 'text', valid: true, hidden: false, required: true },
    Email: { value: "", type: 'email', valid: true, hidden: false, required: false },
    Rol: { value: "", type: 'text', valid: true, hidden: false, required: false },
    Posicion: { value: "", type: 'text', valid: true, hidden: false, required: false },
    Telefono: { value: "", type: 'number', valid: true, hidden: false, required: false },
    Password: { value: "", type: 'password', valid: true, hidden: true, required: false, error: '' },
    confirmPassword: { value: "", type: 'password', valid: true, hidden: true, required: false, error: '' },
});